import { jsx as _jsx } from "react/jsx-runtime";
import { StyleSheet } from 'react-native';
import { theme } from '@xbto/design-system';
import { Col, Icon } from '../../atoms';
export function ActionIcon(props) {
    return (_jsx(Col.C, { style: $.container, children: _jsx(Icon, Object.assign({}, props, { size: "xs", color: "primary" })) }));
}
const $ = StyleSheet.create({
    container: {
        width: theme.spacing['6'],
        height: theme.spacing['6'],
        backgroundColor: theme.color.background.white,
        borderRadius: theme.radius.sm,
        borderWidth: 1,
        borderColor: theme.color.border.primary,
    },
});
